import DrawControl from "ole/src/control/draw";

import ModifyControl from "../components/Editor/ModifyControl";

export const getModifyControl = (editor) => {
  return editor?.controls?.getArray().find((c) => {
    return c instanceof ModifyControl;
  });
};

export const getDrawControls = (editor) => {
  return editor?.controls?.getArray().filter((c) => {
    return c instanceof DrawControl;
  });
};

/**
 * Clear features in OLE select
 */
const clearSelectedFeatures = (editor) => {
  if (!editor) {
    return;
  }
  getModifyControl(editor)?.selectInteraction?.getFeatures().clear();
};

export default clearSelectedFeatures;
